import { QueryClient } from '@tanstack/react-query'

// Exported (rather than instantiated inline in main.tsx) so non-React code —
// notably auth.store's `logout()` — can clear it directly. Login/logout
// changes what a query like `investigations/:id/read` is allowed to return,
// but its cache key doesn't encode the auth state, so a stale cache entry
// would otherwise keep serving privileged content after logout until a hard
// page reload.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})
